import { AppSwitcher as ElementsAppSwitcher } from '@reapit/elements'
import { getProductLink } from './productLinks'

interface AppSwitcherMenuContentProps {
  accessibleProductIds: string[]
}

export default function AppSwitcherMenuContent({ accessibleProductIds }: AppSwitcherMenuContentProps) {
  const displayableProductsForYourAppsGroup =
    ElementsAppSwitcher.getDisplayableProductsForYourAppsGroup(accessibleProductIds)
  const displayableProductsForExploreGroup =
    ElementsAppSwitcher.getDisplayableProductsForExploreGroup(accessibleProductIds)

  const hasAtLeastOneProductInYourAppsGroup = displayableProductsForYourAppsGroup.length > 0
  const hasAtLeastOneProductInExploreGroup = displayableProductsForExploreGroup.length > 0

  return (
    <>
      {hasAtLeastOneProductInYourAppsGroup && (
        <ElementsAppSwitcher.YourAppsMenuGroup>
          {displayableProductsForYourAppsGroup.map((productId) => (
            <ElementsAppSwitcher.ProductMenuItem
              key={productId}
              href={getProductLink(productId, true)}
              productId={productId}
            />
          ))}
        </ElementsAppSwitcher.YourAppsMenuGroup>
      )}
      {hasAtLeastOneProductInExploreGroup && (
        <ElementsAppSwitcher.ExploreMenuGroup>
          {displayableProductsForExploreGroup.map((productId) => (
            <ElementsAppSwitcher.ProductMenuItem
              key={productId}
              href={getProductLink(productId, false)}
              productId={productId}
            />
          ))}
        </ElementsAppSwitcher.ExploreMenuGroup>
      )}
    </>
  )
}
